import SiteFooter, { Props } from './SiteFooter';

export default SiteFooter as React.ComponentType<Props>;
